import script from "./DmFieldsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DmFieldsCard.vue?vue&type=script&setup=true&lang=js"

import "./DmFieldsCard.vue?vue&type=style&index=0&id=6a9382f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9382f6"]])

export default __exports__